import Hook from "../utils/hook"
import { getNavigatorGeoLocationCoordinates } from "../utils/geo"

export const Stops = Hook(`Stops`, {
  refs: [`locateButton`],
  targets: [`input`, `list`, `listItem`, `locateButton`],
  values: { locateError: String },
  actions: [
    {
      name: `inputFocus`,
      targets: `input`,
      type: `focus`,
    },
    {
      name: `inputBlur`,
      targets: `input`,
      type: `blur`,
    },
    {
      name: `inputKeyup`,
      targets: `input`,
      type: `keyup`,
    },
    {
      name: `listItemBlur`,
      targets: `listItem`,
      type: `blur`,
    },
    {
      name: `listItemKeyup`,
      targets: `listItem`,
      type: `keyup`,
    },
    {
      name: `locateButtonClick`,
      target: `locateButton`,
      type: `click`,
    },
  ],

  handleEventToSelf(
    name
    // data
  ) {
    switch (name) {
      case `departure_stop_located`: {
        if (this.locateButtonRef) this.locateButtonRef.setLoading(false)
        break
      }

      // case `set_stop`: {
      //   if (data.type == `departure` && this.locateButtonRef)
      //     this.locateButtonRef.setLoading(false)
      //   this.inputTargets.find(
      //     (t) => t.getAttribute(`phx-value-type`) == data.type
      //   ).value = data.title
      //   break
      // }
    }
  },

  inputFocusAction(e, target) {
    target.value = ``

    window.setTimeout(() => {
      this.pushEventToSelf(`set_list_active`, {
        type: target.getAttribute(`phx-value-type`),
      })
    }, 100)
  },

  inputKeyupAction(e, target) {
    if (e.key == `Escape`) {
      target.blur()
      this.pushEventToSelf(`unset_list_active`)
    }
  },

  inputBlurAction() {
    window.setTimeout(() => {
      if (!this.listTarget?.contains(document.activeElement))
        this.pushEventToSelf(`unset_list_active`)
    }, 100)
  },

  listItemBlurAction() {
    window.setTimeout(() => {
      if (!this.listTarget?.contains(document.activeElement))
        this.pushEventToSelf(`unset_list_active`)
    }, 100)
  },

  listItemKeyupAction(e, target) {
    if (e.key == `Escape`) {
      const type = target.getAttribute(`phx-value-type`)
      this.inputTargets
        .find((t) => t.getAttribute(`phx-value-type`) == type)
        ?.focus()
    }
  },

  locateButtonClickAction() {
    if (this.locateButtonRef) this.locateButtonRef.setLoading(true)

    getNavigatorGeoLocationCoordinates()
      .then(({ lng, lat }) =>
        this.pushEventToSelf(`locate_departure_stop`, { lng, lat })
      )
      .catch(() => {
        this.putFlash({
          type: `error`,
          text: this.locateErrorValue,
        })
        if (this.locateButtonRef) this.locateButtonRef.setLoading(false)
      })
      .finally(() => {
        this.locateButtonTarget?.focus()
      })
  },
})

export const StopsMap = Hook(`StopsMap`, {
  refs: [`map`],
  values: { departureId: String, arrivalId: String, phxHideModal: String },

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (!this.mapRef) break

        this.mapRef.send(`setFullscreenIfIsMobile`, true)

        this.mapRef.send(`setTraffic`, {
          startId: this.departureIdValue,
          finishId: this.arrivalIdValue,
        })
        break
      }

      case `closeRequested`: {
        if (this.phxHideModalValue) this.js().exec(this.phxHideModalValue)
        break
      }
    }
  },
})
